import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const MobileCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show CTA after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-white border-t border-gray-200 shadow-[0_-4px_12px_rgba(0,0,0,0.1)] animate-slideUp">
      <div className="grid grid-cols-2 gap-0">
        <a
          href="tel:+12695551234"
          className="flex items-center justify-center py-4 bg-[#10B981] text-white font-semibold text-[15px] hover:bg-[#059669] transition-colors cursor-pointer"
        >
          <i className="ri-phone-line text-xl mr-2"></i>
          Call Now
        </a>
        <Link
          to="/contact"
          className="flex items-center justify-center py-4 bg-[#1A2B4A] text-white font-semibold text-[15px] hover:bg-[#2A3B5A] transition-colors cursor-pointer"
        >
          <i className="ri-mail-line text-xl mr-2"></i>
          Get Estimate
        </Link>
      </div>
    </div>
  );
};

export default MobileCTA;